var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notesData)?_c('InnerCardInfo',{ref:"inner",attrs:{"label":_vm.localStorage.translations.pages['setting-personal_area'].labels['primechanie'],"data":_vm.notesData}},[_c('template',{slot:"edit_block"},[_vm._t("default")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }